import * as math from 'mathjs';

const round = (value) => {
  return math.round(value, 2);
};

const add = (a, b) => {
  return round(math.add(a, b));
};

const subtract = (a, b) => {
  return round(math.subtract(a, b));
};

const multiply = (a, b) => {
  return round(math.multiply(a, b));
};

const divide = (a, b) => {
  return round(math.divide(a, b));
};

export { add, subtract, multiply, divide, round };